<template>
  <div>
    <Navbar />
    <Banner />
    <Schedule />
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src

import Banner from "@/components/Banner";
import Schedule from "@/components/Schedule";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default {
  name: "Home",
  components: {
    Banner,
    Schedule,
    Footer,
    Navbar
  }
};
</script>
